import { useMemo } from 'react';
import { generateAuthUrl } from 'api';
import { THIRD_PARTY_AUTH_SERVICE } from 'api/constants';
import { getEnv } from 'config';
import { TokenInfoData } from 'oauth/types';
import useOAuthenticator, {
  AuthInitiator,
  UseOAuthenticatorConfig,
  UseOAuthenticatorResult,
} from '../useOAuthenticator';

export type UseGoogleLoginConfig = Omit<
  UseOAuthenticatorConfig<TokenInfoData>,
  'authInitiator'
>;

const createGoogleAuthInitiator =
  (): AuthInitiator<TokenInfoData> => async () => {
    const { requestUrl } = await generateAuthUrl('google');

    if (requestUrl) {
      return {
        type: 'unauthenticated',
        requestUrl,
      };
    }

    throw new Error('Missing requestUrl for Google login');
  };

export default function useGoogleLogin({
  ...config
}: UseGoogleLoginConfig): UseOAuthenticatorResult {
  const authInitiator = useMemo(() => createGoogleAuthInitiator(), []);

  return useOAuthenticator({
    authInitiator,
    postMessageOrigin: getEnv(THIRD_PARTY_AUTH_SERVICE),
    ...config,
  });
}
